import { ReactNode } from 'react';
import { Option } from '@/legacy/types';
import { Select } from '../primitives';
import { Placement } from '@floating-ui/react';
import { useTranslation } from 'react-i18next';
import { formPlaceholderTradPrefix } from '@/legacy/i18n';
import { TriggerVariant } from '../types';

type ControlledSelectProps = {
	name: string;
	options: Option[];
	value: string | number | (string | number)[];
	onChange: (v: any) => void;
	placeholder?: string;
	label?: string;
	error?: string;
	isLoadingOptions?: boolean;
	searchable?: boolean;
	placement?: Placement;
	showScrollbar?: boolean;
	helperText?: string | null;
	spacing?: boolean;
	ignoreSize?: boolean;
	variant?: TriggerVariant;
	displayValue?: ReactNode;
	required?: boolean;
};

export function ControlledSelect({
	options,
	value,
	onChange,
	placeholder,
	label,
	error,
	isLoadingOptions,
	searchable,
	name,
	showScrollbar = true,
	helperText,
	spacing = true,
	ignoreSize = false,
	variant = 'button',
	displayValue,
	required = false,
}: ControlledSelectProps) {
	const { t } = useTranslation();
	return (
		<Select.Root
			options={options}
			value={value}
			onChange={onChange}
			floatingUiProps={{ strategy: 'fixed', ignoreSize: ignoreSize, autoplacement: true }}
		>
			<div className={spacing ? 'mb-6' : undefined}>
				{label && (
					<Select.Label
						label={label}
						name={name}
						required={required}
					/>
				)}
				<Select.Trigger
					placeholder={placeholder || t(`${formPlaceholderTradPrefix}.select_one_option`)}
					fieldError={error}
					variant={variant}
					displayValue={displayValue}
				/>
				<Select.HelperText error={error}>{helperText}</Select.HelperText>
				<Select.Positioner className='w-full'>
					<Select.Panel isLoadingOptions={isLoadingOptions}>
						<Select.OptionsList
							searchable={searchable}
							showScrollbar={showScrollbar}
						/>
					</Select.Panel>
				</Select.Positioner>
			</div>
		</Select.Root>
	);
}
